import type { TransactionsFetchResponse } from '@shared/transactions-types';
import type { SearchState } from '@shared/transactions-search-state';
import { createQuery } from '@luna/api';

import type { TransactionsUrlArgs } from '../TransactionsApiService';
import { getTransactionsUrl } from '../TransactionsApiService';
import { fetchMultipleTransactions } from '../list/fetchMultipleTransactions';

interface Payload {
    productId?: string;
    searchState?: Partial<SearchState>;
    skip?: boolean;
}

type Metadata = Pick<TransactionsFetchResponse, 'metadata' | 'totalElements'>;

const EMPTY_SEARCH_STATE: SearchState = { amount: {}, dates: {}, billIdRange: {} };

const getProbeParams = ({ productId, searchState }: Payload): TransactionsUrlArgs => ({
    productId,
    searchState: { ...EMPTY_SEARCH_STATE, ...searchState },
    pageSize: 1,
    page: 0,
});

export const payloadCreator = async (payload: Payload): Promise<Metadata | undefined> => {
    if (payload.skip) {
        return undefined;
    }

    const response = await fetchMultipleTransactions(getProbeParams(payload));

    return {
        totalElements: response.totalElements,
        metadata: response.metadata,
    };
};

export const [useTransactionsMetadata, { invalidateAllCacheKeys: invalidateTransactionsMetadata }] =
    createQuery({
        name: 'transactions/metadata',
        cacheKey: (payload) => (payload.skip ? '' : getTransactionsUrl(getProbeParams(payload))),
        payloadCreator,
    });
